module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-wrap",
    class: {
      'box-wrap-min': _vm.min
    }
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('img'), _vm._v(" "), _vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-86d1c14c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/runda/dashboard/components/common/boxWrap/index.vue
// module id = 2060
// module chunks = 2